import { defineAsyncComponent } from 'vue'
export default {
  city: defineAsyncComponent(() => import("/app/layouts/city.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  fullscreen: defineAsyncComponent(() => import("/app/layouts/fullscreen.vue").then(m => m.default || m)),
  guest: defineAsyncComponent(() => import("/app/layouts/guest.vue").then(m => m.default || m)),
  "market-report": defineAsyncComponent(() => import("/app/layouts/marketReport.vue").then(m => m.default || m))
}